import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type OfferTimerProps = {
  label: string;
  className?: string;
};
export function OfferTimer({
  label,
  className = ''
}: OfferTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    name: 'Horas'
  }, {
    value: minutes,
    name: 'Min'
  }, {
    value: seconds,
    name: 'Seg'
  }];
  return <div className={`flex flex-col items-center ${className}`} role="timer" aria-label={`${label}: ${hours} horas, ${minutes} minutos`} data-id="element-118" data-mp="dz43810he9nb">
      <p className="flex items-center gap-1.5 font-display text-[11px] font-extrabold uppercase tracking-[0.16em] text-sun sm:text-xs" style={{
      color: "#F0E90A"
    }} data-id="element-119" data-mp="40ep8jbph9cc">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-120" data-mp="8xofu2atzr1r" />
        {label}
      </p>
      <div className="mt-2 flex items-start gap-1.5" aria-hidden="true" data-id="element-121" data-mp="2op2jo19i6wan">
        {units.map((u, i) => <React.Fragment key={u.name} data-id="element-122" data-mp="2tr1m98xf5p6j" data-mpi={i}>
            {i > 0 && <span className="pt-2 font-display text-xl font-extrabold leading-none text-sun" data-id="element-123" data-mp="1hdcayflzjfjm">:</span>}
            <span className="flex flex-col items-center" data-id="element-124" data-mp="1dcsgjjssqq16">
              <span className="btn-gold relative flex h-11 w-12 items-center justify-center overflow-hidden rounded-lg font-display text-2xl font-extrabold tabular-nums text-ink" data-id="element-125" data-mp="1ded58ssfjer4">
                <span className="relative" data-id="element-126" data-mp="1mbnjmn0jnk09">{String(u.value).padStart(2, '0')}</span>
              </span>
              <span className="mt-1 text-[9px] font-bold uppercase tracking-wider text-brand-100" data-id="element-127" data-mp="20ax1rs8b8o6v">{u.name}</span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}